import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { JiraCmsTasksComponent } from './jiraCmsTasks/jira-cms-tasks.component';
import { MatTableModule } from '@angular/material/table';

import { JiraCmsManagerComponent } from './jira-cms-manager.component';
import { MatDatepickerModule, MatInputModule, MatNativeDateModule, MatSortModule } from '@angular/material';
import { Utils } from '@src/utils/util';

@NgModule({
    imports: [
        SharedModule,
        MatTableModule, 
        MatSortModule, 
        MatDatepickerModule, 
        MatInputModule, 
        MatNativeDateModule ,
    ],
    declarations: [JiraCmsManagerComponent,JiraCmsTasksComponent],
    entryComponents: [JiraCmsManagerComponent],
    exports: [JiraCmsManagerComponent],
    providers: [MatDatepickerModule, MatNativeDateModule, Utils]
})
export class JiraCmsManagerModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/jiraCMSManager-ang7/jira-cms-manager.moudle.ts